<script lang="ts" setup>
const isVisible =
  String(import.meta.env.VITE_APP_ENV || import.meta.env.MODE || '')
    .trim()
    .toLowerCase() === 'local'
</script>

<template>
  <div
    v-if="isVisible"
    aria-hidden="true"
    class="pointer-events-none fixed inset-0 z-[9999] border-4 border-warn-400"
  />
</template>
